module.exports = __webpack_public_path__ + "static/preview-tabs-style-selection-2b92af5f40c976e2b547da6bb74fcc7d.png";